import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

const BottomNavChargePointsIcon = ({ primaryColor = '#414042', secondaryColor = '#414042', size, style, textColor, ...rest }) => (
    <SvgIcon viewBox='0 0 13.13 17.32' style={size ? { ...style, fontSize: size, width: size, height: size } : style} {...rest}>
        <path
            fill={primaryColor}
            d='M10.76,2.06c-.19,0-.29.1-.29.27l-1.08-.56v4.95c0,.54-.27.83-.85.83l-.94,1.95-1.21,1.83h1.42l-3.16,3.97.94-2.97h-.81l.85-2.81,1.96-.02.94-1.95H3.91c-.56,0-.83-.29-.83-.83V1.77c0-.56.27-.83.83-.83h4.64c.58,0,.85.27.85.83l1.08.56v2.16c.02.15.12.23.29.23h.71v7.72h-1.29V.83c0-.29-.06-.5-.21-.64-.14-.13-.35-.19-.62-.19H3.1c-.25,0-.46.06-.6.19-.15.14-.23.35-.23.64v14.59H.85c-.58,0-.85.29-.85.83v1.08h12.47v-1.08c0-.54-.29-.83-.85-.83h-1.44v-2.31h1.42c.06,0,.1,0,.15-.04,0,.02.02.02.04.02.1,0,.17-.02.25-.1.06-.08.1-.15.1-.25V4.72h.71c.17,0,.27-.1.27-.29v-2.1c0-.17-.1-.27-.27-.27h-2.1Z'
        />
        <polyline fill={secondaryColor} points='8.15 1.26 6.74 3.38 8.39 3.38 4.74 7.97 5.83 4.54 4.89 4.54 5.87 1.28 8.15 1.26' />
    </SvgIcon>
);

export default BottomNavChargePointsIcon;
